import * as React from "react";
import type { SVGProps } from "react";
const SvgFolderOpen03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5.4 5.33v-1.8a1.2 1.2 0 0 1 1.2-1.2H18a1.2 1.2 0 0 1 1.2 1.2v4.8M2.4 19.27V6.988a1.2 1.2 0 0 1 1.2-1.2H9.32l2.765 2.954H20.4a1.2 1.2 0 0 1 1.2 1.2v9.329a2.4 2.4 0 0 1-2.4 2.4H4.8a2.4 2.4 0 0 1-2.4-2.4"
    />
  </svg>
);
export default SvgFolderOpen03;
